import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    loading: false,
    activo: false,
    data: {},
    fc_33: {
        fechasolicitud: fechaHoy,
        numerocliente: '',
        resposableinstalaciones: '',
        telefono: '',
        correoelectronico: '',
        calle: '',
        numeroexterior: '',
        numerointerior: '',
        codigopostal: '',
        colonia: '',
        localidad: '',
        delegacionmunicipio: '',
        estado: '',
        entregahologramas: false,
        inspeccionenvasadonacional: false,
        emicioncertificadonomparaventan: false,
        fechavisitapropuesta: fechaHoy,
        informacionadicionalsobreactivi: '',
    },
    loading: false,
    productos: {},
    paginaActiva: 1,
    fc_33Map: {},
    productosMap: [],
    modoProceso:false,
    modoVerDetalle:false,
    modoRecibidasCorregidas:false,
    filesMap: [],
    filesProductosMap: []
}

//types
const ACTUALIZAR_FC_33_PAGINA = 'ACTUALIZAR_FC_33_PAGINA'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const ACTUALIZAR_FC_33_ESTATUS_EXITO = 'ACTUALIZAR_FC_33_ESTATUS_EXITO'
const AGREGAR_FC_33_EXITO_MAP = 'AGREGAR_FC_33_EXITO_MAP'
const AGREGAR_ANEXO_FC_33_EXITO_MAP = 'AGREGAR_ANEXO_FC_33_EXITO_MAP'
const OBTENER_ID_CLIENTE_EXITO = 'OBTENER_ID_CLIENTE_EXITO'
const OBTENER_FC_33_MAP_EXITO = 'OBTENER_FC_33_MAP_EXITO'
const AGREGAR_FC_33_EXITO = 'AGREGAR_FC_33_EXITO'
const AGREGAR_FC_33_MAP_EXITO = 'AGREGAR_FC_33_MAP_EXITO'
const OBTENER_DETALLE_FC_33_EXITO = 'OBTENER_DETALLE_FC_33_EXITO'
const ACTUALIZAR_FC_33_EXITO = 'ACTUALIZAR_FC_33_EXITO'
const OBTENER_DETALLE_FC_33_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_33_CON_MAPS_EXITO'
const ACEPTAR_SOLICITUD_FC33_EXITO = 'ACEPTAR_SOLICITUD_FC33_EXITO'
const GENERAR_OFICIOS_FC33_EXITO = 'GENERAR_OFICIOS_FC33_EXITO'
const ACTUALIZAR_FC_33_SOLICITUD_MODAL_EXITO = 'ACTUALIZAR_FC_33_SOLICITUD_MODAL_EXITO'

export const obtenerSolicitudDetalleFC_33 = createAsyncThunk(
    OBTENER_DETALLE_FC_33_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_33/obtenerFormatoFC33_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_33Estatus = createAsyncThunk(
    ACTUALIZAR_FC_33_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarMapFC_33Accion = createAsyncThunk(
    AGREGAR_FC_33_EXITO_MAP,
    async (data) => {
        try {
            let solicitud = { data: data.solicitud[0] }
            let productosMap = data.productosMap
            let archivosProductosMap = data.archivosProductosMap
            delete solicitud.idfc33_envasadonacionamap

            const agregarFC_33Map = host + `MapSolicitud/agregarMapFC_33_Solicitud`
            const agregarAnexosProductosMap = host + 'MapSolicitud/agregarMapFC_33_AnexoProducto'
            const agregarFC_33ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_33_ArchivosProductos`

            const res = await axios.post(agregarFC_33Map, solicitud)

            for (const anexo of productosMap) {
                delete anexo.idfc33_anexoproductomap
                await axios.post(agregarAnexosProductosMap, { data: anexo })
            }
            for (const anexo of archivosProductosMap) {
                delete anexo.idfc33_archivoproductomap
                await axios.post(agregarFC_33ArchivosproductosMap, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_33Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_33_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const archivosParaActualizarProductos = data.archivosProductos

            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`
            const urlActualizarArchivosProductos = host + 'FC_33/actualizarArchivoProductoFC_33'

            const res = await axios.put(actualizarFC_33, solicitud)

            for (const anexo in archivosParaActualizarProductos) {
                let resAnexo = await axios.put(urlActualizarArchivosProductos, { data: archivosParaActualizarProductos[anexo] })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_33Map = createAsyncThunk(
    OBTENER_FC_33_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_33_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            const Map = await obtenerProductosMap(solicitudId)
            console.log("los que regresa es ", Map)
            productosMap.push(Map.anexoProductoMap)
            //mapFiles.push(Map.filesGeneralMap)
            filesProductosMap.push(Map.filesProductosMap)

            const solicitudMap = {
                data: res.data.data,
                //mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_33/obtenerFormatoFC33_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_33_AnexoProducto/`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_33_ArchivosGenerales/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_33_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_33archivos
        const filesProductos = res.data.data.fc_33_anexoproducto
        {/*const filesGeneralMap = []
        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_33archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_33archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }*/}

        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_33archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_33archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_33archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            }
        }
        // const filesProductos = res.data.data
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_33_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc33_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let Map = { anexoProductoMap: anexoProductoMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_33SolicitudMap = createAsyncThunk(
    ACTUALIZAR_FC_33_EXITO,
    async (data) => {
        try {
            console.log("la data es ", data )
            const solicitud = { data: data.solicitud }
            const idfc33_envasadonacionamap = data.idfc33_envasadonacionamap
            const productosParaActualizar = data.productosMap
            const archivosPrincipalMap = data.archivosPrincipalMap
            const archivosProductosMap = data.archivosProductosMap
            //const agregarFC_33ArchivosMap = host + `MapSolicitud/agregarMapFC_33_ArchivosGenerales`
            const agregarFC_33ArchivosproductosMap = host + `MapSolicitud/agregarMapFC_33_ArchivosProductos`

            const actualizarFC_33Map = host + `MapSolicitud/actualizarMapFC_33_Solicitud`
            const urlActualizarAnexoProductos = host + 'MapSolicitud/actualizarMapFC_33_AnexoProducto'
            //const urlActualizarArchivosGenerales = host + 'MapSolicitud/actualizarMapFC_33_ArchivosGenerales'
            const urlActualizarArchivosproductos = host + 'MapSolicitud/actualizarMapFC_33_ArchivosProductos'
            solicitud.data[0].idfc33_envasadonacionamap = idfc33_envasadonacionamap
            console.log("los datos antes de actualizar ", solicitud)
            const res = await axios.put(actualizarFC_33Map, {data:solicitud.data[0]})


            for (let anexo of productosParaActualizar) {
                let resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
            }
            {/*for (let anexo of archivosPrincipalMap) {
                if (anexo.idfc33_archivomap != "" && anexo.idfc33_archivomap != null && anexo.idfc33_archivomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivosGenerales, { data: anexo })
                } else {
                    delete anexo.idfc33_archivomap
                    let resAnexo = await axios.post(agregarFC_33ArchivosMap, { data: anexo })
                }

            }*/}
            for (let anexo of archivosProductosMap) {
                if (anexo.idfc33_archivoproductomap != "" && anexo.idfc33_archivoproductomap != null && anexo.idfc33_archivoproductomap != undefined) {
                    let resAnexo = await axios.put(urlActualizarArchivosproductos, { data: anexo })
                } else {
                    delete anexo.idfc33_archivoproductomap
                    let resAnexo = await axios.post(agregarFC_33ArchivosproductosMap, { data: anexo })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerIdCliente = createAsyncThunk(
    OBTENER_ID_CLIENTE_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerSolicitudDetalleFC_33ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_33_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_33/obtenerFormatoFC33_ConDetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const aceptarSolicitudFC_33 = createAsyncThunk(
    ACEPTAR_SOLICITUD_FC33_EXITO,
    async (data) => {
        try {

            const { idcliente, idfc33_solicitudenvasadonaciona, productos } = data

            const urlAgregarProductosCliente = host + 'InformacionValida/agregarProductosCliente'
            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'

            for (let i in productos) {
                const { idfc33_anexoproducto, idfc33_solicitudenvasadonaciona, fc_33archivoproducto, ...anexo } = productos[i]
                anexo.idcliente = idcliente
                anexo.idtipoproductos = 2
                const resProducto = await axios.post(urlAgregarProductosCliente, { data: anexo })
                const idproductocliente = resProducto.data.data.idproductocliente
                for (const j in fc_33archivoproducto) {
                    const { idfc_33archivoproducto, idfc33_anexoproducto, fc_33archivoproductomap, ...restFile } = fc_33archivoproducto[j]
                    restFile.nombreTabla = 'archivoproductocliente'
                    restFile.nameFK = 'idproductocliente'
                    restFile.idFK = idproductocliente
                    restFile.observaciones = fc_33archivoproductomap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }

            return true
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarDocumentosFC_33 = createAsyncThunk(
    GENERAR_OFICIOS_FC33_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

//Para guardar la información del modal en atención a clientes
export const actualizarFC_33SolicitudModal = createAsyncThunk(
    ACTUALIZAR_FC_33_SOLICITUD_MODAL_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }            
            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`            
            const res = await axios.put(actualizarFC_33, solicitud)            
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc33Slice = createSlice({
    name: 'fc33Slice',
    initialState: dataInicial,
    reducers: {
        actualizarPaginaActivaFC_33(state, { payload }) {
            state.paginaActiva = payload
        },
        guardarCambiosFC_33Solicitud(state, { payload }) {
            state.fc_33 = payload
        },
        agregarFC_33AnexoProducto(state, { payload }) {
            state.productos = payload
        },
        resetDataFC_33(state, { payload }) {
            return dataInicial
        },
        setModoProcesoFC_33(state, { payload }) {
            state.modoProceso = payload
        },
        setModoVerDetalleFC_33(state, { payload }) {
            state.modoVerDetalle = payload
        },
        setModoRecibidasCorregidasFC_33(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
    },
    extraReducers: {
        [obtenerSolicitudDetalleFC_33.fulfilled]: (state, { payload }) => {
            state.data = payload
        }, 
        [obtenerFC_33Map.fulfilled]: (state, { payload }) => {
            state.fc_33Map = payload.data
            state.productosMap = payload.productosMap[0]
            //state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
        },
        [agregarMapFC_33Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_33Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerIdCliente.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_33Map.fulfilled]: (state, { payload }) => {
            state.fc_33Map = payload.data
            state.productosMap = payload.productosMap[0]
            //state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
        },
        [actualizarFC_33Solicitud.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_33SolicitudMap.fulfilled]: (state, { payload }) => {
        },
        [obtenerSolicitudDetalleFC_33ConMaps.fulfilled]: (state, { payload }) => {
        },
        [generarDocumentosFC_33.fulfilled]: (state, { payload }) => {
        },
    },
})

//actions
export const {
    actualizarPaginaActivaFC_33,
    guardarCambiosFC_33Solicitud,
    agregarFC_33AnexoProducto,
    resetDataFC_33,
    setModoProcesoFC_33,setModoVerDetalleFC_33,
    setModoRecibidasCorregidasFC_33
} = fc33Slice.actions

export const FC33ReducerAtencionACliente = fc33Slice.reducer